// Republic Atlas - Office Service

import api from './api';
import type { PoliticalOffice, ApiResponse } from '@/types';

export interface OfficeFilters {
  jurisdictionId?: string;
  officeType?: string;
  electionCycle?: number;
  page?: number;
  pageSize?: number;
}

export const officeService = {
  /**
   * Get all offices with optional filters
   */
  async getOffices(filters?: OfficeFilters): Promise<ApiResponse<PoliticalOffice[]>> {
    const params = new URLSearchParams();
    if (filters?.jurisdictionId) params.append('jurisdiction_id', filters.jurisdictionId);
    if (filters?.officeType) params.append('office_type', filters.officeType);
    if (filters?.electionCycle) params.append('election_cycle', filters.electionCycle.toString());
    if (filters?.page) params.append('page', filters.page.toString());
    if (filters?.pageSize) params.append('page_size', filters.pageSize.toString());

    const response = await api.get<ApiResponse<PoliticalOffice[]>>(`/offices?${params}`);
    return response.data;
  },

  /**
   * Get a single office by ID
   */
  async getOffice(id: string): Promise<PoliticalOffice> {
    const response = await api.get<PoliticalOffice>(`/offices/${id}`);
    return response.data;
  },

  /**
   * Get offices by jurisdiction
   */
  async getOfficesByJurisdiction(jurisdictionId: string): Promise<PoliticalOffice[]> {
    const response = await api.get<ApiResponse<PoliticalOffice[]>>(
      `/jurisdictions/${jurisdictionId}/offices`
    );
    return response.data.data;
  },

  /**
   * Search offices by name
   */
  async searchOffices(query: string): Promise<PoliticalOffice[]> {
    const response = await api.get<ApiResponse<PoliticalOffice[]>>(
      `/offices/search?q=${encodeURIComponent(query)}`
    );
    return response.data.data;
  },
};

export default officeService;

